/* Moravský butik — carrossel "Nejprodávanější" na pesquisa e no menu hambúrguer. */
(function () {
  var tpl = document.getElementById('mb-bestsellers-tpl');
  if (!tpl) return;

  function initSlider(root) {
    var track = root.querySelector('[data-mb-bs-track]');
    var prev = root.querySelector('[data-mb-bs-prev]');
    var next = root.querySelector('[data-mb-bs-next]');
    var bar = root.querySelector('[data-mb-bs-bar]');
    if (!track) return;

    /* O tema bloqueia o scroll da página quando a pesquisa/menu estão abertos;
       este atributo diz-lhe que o carrossel pode deslizar. */
    track.setAttribute('data-scroll-lock-scrollable', '');

    function step() {
      var item = track.querySelector('.mb-bs__item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var x = track.scrollLeft;
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
      if (bar) {
        var ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        var w = Math.max(ratio, 0.15) * 100;
        var pos = max > 0 ? (x / max) * (100 - w) : 0;
        bar.style.width = w + '%';
        bar.style.transform = 'translateX(' + (pos / w) * 100 + '%)';
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);

    /* Toque: impedir que o bloqueio de scroll do tema cancele o deslize horizontal. */
    track.addEventListener('touchmove', function (e) { e.stopPropagation(); }, { passive: true });

    /* Rato: arrastar para o lado (desktop). */
    var down = false, moved = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      track.classList.remove('is-dragging');
    });
    /* Depois de arrastar, não abrir o produto por engano. */
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    update();
  }

  function cloneInto(container, where) {
    if (!container || container.querySelector('[data-mb-bs]')) return null;
    var node = tpl.content.firstElementChild.cloneNode(true);
    if (where === 'after') container.insertAdjacentElement('afterend', node);
    else container.appendChild(node);
    initSlider(node);
    return node;
  }

  function setup() {
    /* Fundo do menu hambúrguer (gavetas do cabeçalho e da secção Mobile menu). */
    document.querySelectorAll('header-drawer .drawer__content__scroll').forEach(function (scroll) {
      var node = cloneInto(scroll);
      if (node) node.classList.add('mb-bs--drawer');
    });

    /* Pesquisa: por baixo do campo, escondido enquanto há texto escrito. */
    document.querySelectorAll('.search-popdown__main').forEach(function (main) {
      if (main.parentElement.querySelector('[data-mb-bs]')) return;
      var node = cloneInto(main, 'after');
      if (!node) return;
      node.classList.add('mb-bs--search');
      var input = main.querySelector('input[type="search"]');
      if (!input) return;
      var toggle = function () { node.hidden = input.value.trim().length > 0; };
      input.addEventListener('input', toggle);
      var form = input.form;
      if (form) form.addEventListener('reset', function () { setTimeout(toggle, 0); });
      toggle();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
